import InitialState from "./InitialState"
import {FETCH_DOCTOR_APPOINTMENTS_SUCCESS} from "../actions/ActionTypes"

export const AppointmentsReducer = function(initialState = InitialState.appointments, action: any) {
    switch (action.type) {
        case FETCH_DOCTOR_APPOINTMENTS_SUCCESS:
            return Object.assign([], action.appointments);
        default:
            return initialState;
    }
}
